export const FeedbackTagCategory = {
  GymEnvironment: 'GYM_ENVIRONMENT',
  Programming: 'PROGRAMMING',
  Whiteboard: 'WHITEBOARD',
} as const;

export type FeedbackTagCategory = (typeof FeedbackTagCategory)[keyof typeof FeedbackTagCategory];

export const FeedbackTag = {
  TooMuchEquipment: 'too_much_equipment',
  NotEnoughSpace: 'not_enough_space',
  TooManyZones: 'too_many_zones',
  TooDifficultToManage: 'too_difficult_to_manage',

  NotEnoughTime: 'not_enough_time',
  NeededMoreRest: 'needed_more_rest',
  FeltUnclearToInstruct: 'felt_unclear_to_instruct',
  CuesNeededMoreDetail: 'cues_needed_more_detail',

  ScreensDidntTranslateWell: 'screens_didnt_translate_well',
  TimerIssues: 'timer_issues',
  FlowFeltDisjointed: 'flow_felt_disjointed',
  HardToAdaptOnTheFly: 'hard_to_adapt_on_the_fly',
} as const;

export type FeedbackTag = (typeof FeedbackTag)[keyof typeof FeedbackTag];

export interface FeedbackTagGroup {
  category: FeedbackTagCategory;
  tags: FeedbackTag[];
}

export const FEEDBACK_TAG_GROUPS: FeedbackTagGroup[] = [
  {
    category: FeedbackTagCategory.GymEnvironment,
    tags: [
      FeedbackTag.TooMuchEquipment,
      FeedbackTag.NotEnoughSpace,
      FeedbackTag.TooManyZones,
      FeedbackTag.TooDifficultToManage,
    ],
  },
  {
    category: FeedbackTagCategory.Programming,
    tags: [
      FeedbackTag.NotEnoughTime,
      FeedbackTag.NeededMoreRest,
      FeedbackTag.FeltUnclearToInstruct,
      FeedbackTag.CuesNeededMoreDetail,
    ],
  },
  {
    category: FeedbackTagCategory.Whiteboard,
    tags: [
      FeedbackTag.ScreensDidntTranslateWell,
      FeedbackTag.TimerIssues,
      FeedbackTag.FlowFeltDisjointed,
      FeedbackTag.HardToAdaptOnTheFly,
    ],
  },
];
